// Shared Socket.IO connection for affiliate chat — one connection per page,
// authenticated by the mars.session cookie, acting as the given identity
// ('user' | 'affiliate'). Components subscribe to 'chat:event' pushes:
//   { conversationId, type: 'message:new'|'message:updated'|'message:deleted', ... }
// Socket pushes are not subject to background-tab timer throttling, so
// notifications fire instantly even with the browser minimized.
import { io } from 'socket.io-client';

const getApiUrl = () => process.env.REACT_APP_API_URL || 'https://mars2.mediacle.net';

let socket = null;
let currentRole = null;

export const getChatSocket = (role) => {
  if (socket && currentRole === role) return socket;
  if (socket) {
    socket.disconnect();
    socket = null;
  }
  currentRole = role;
  socket = io(getApiUrl(), {
    withCredentials: true,
    auth: { actor: role },
    // Falls back to HTTP long-polling automatically if the proxy blocks websockets.
    reconnectionDelayMax: 10000
  });
  return socket;
};

// Subscribe to chat events; returns an unsubscribe function.
export const onChatEvent = (role, handler) => {
  const s = getChatSocket(role);
  s.on('chat:event', handler);
  return () => s.off('chat:event', handler);
};
